import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, HStack, Text, VStack } from "@chakra-ui/react";
import { useAuth } from "../../context/AuthContext";
import { useCallPopup } from "../../context/CallPopupContext";
import { formatTimeStampToDay } from "../../logics/timeLogic";
import CallLoadingSkeleton from "../../loading/CallLoadingSkeleton";
import {
  FormatCallDuration,
  getCallDirectionIcons,
  getCallTypeIcons,
} from "../../logics/callLogic";
import { ChatTitle } from "../../logics/chatLogic";
import { MdInfoOutline } from "react-icons/md";

const CallHistory = ({ callList, loading }) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { openCallPopup } = useCallPopup();

  const handleOpenCallModal = (pCallData) => {
    const callData = {
      chatId: pCallData.chat?._id,
      chatName: pCallData.chat?.chatName,
      isGroup: pCallData.chat?.isGroup,
      members: pCallData.chat?.members,
      type: pCallData.type,
    };
    openCallPopup(callData);
  };

  if (loading) {
    return <CallLoadingSkeleton></CallLoadingSkeleton>;
  }

  return (
    <VStack align="stretch" spacing={0} w="100%">
      {callList &&
        callList.map((callData, index) => (
          <Box
            key={callData._id}
            borderBottom={index < callList.length - 1 ? "1px solid" : "none"}
            borderColor="gray.100"
          >
            <HStack
              w="full"
              p={4}
              spacing={3}
              bg="white"
              _hover={{ bg: "gray.50", cursor: "pointer" }}
              _active={{ bg: "gray.100" }}
              align="flex-start"
            >
              <Avatar
                size="md"
                name={ChatTitle(callData.chat, currentUser)}
                fontSize="sm"
                fontWeight="600"
              />
              <VStack align="start" spacing={1} w="100%" flex="1">
                <HStack w="100%" justify="space-between" align="center">
                  <Text
                    cursor="pointer"
                    fontWeight="600"
                    fontSize="md"
                    color="gray.800"
                    onClick={() => handleOpenCallModal(callData)}
                    isTruncated
                    flex="1"
                  >
                    {ChatTitle(callData.chat, currentUser)}
                  </Text>
                  <Text fontSize="xs" color="gray.400" fontWeight="500">
                    {formatTimeStampToDay(callData.createdAt)}
                  </Text>
                </HStack>

                <HStack w="100%" justify="space-between" align="center">
                  <HStack
                    spacing={2}
                    cursor="pointer"
                    onClick={() => handleOpenCallModal(callData)}
                    flex="1"
                  >
                    {getCallTypeIcons(callData.type)}
                    {getCallDirectionIcons(callData, currentUser)}
                    <Text fontSize="sm" color="gray.600">
                      {FormatCallDuration(callData, currentUser)}
                    </Text>
                  </HStack>
                  <Box
                    cursor="pointer"
                    color="teal.500"
                    _hover={{ color: "teal.600" }}
                    onClick={() =>
                      navigate(`/chats/${callData.chat._id}/edit`, {
                        state: { from: "/calls" },
                      })
                    }
                  >
                    <MdInfoOutline size={18} />
                  </Box>
                </HStack>
              </VStack>
            </HStack>
          </Box>
        ))}
    </VStack>
  );
};

export default CallHistory;
